import { render, staticRenderFns } from "./TwDashBoardNotification.vue?vue&type=template&id=3479a291&scoped=true&"
import script from "./TwDashBoardNotification.vue?vue&type=script&lang=js&"
export * from "./TwDashBoardNotification.vue?vue&type=script&lang=js&"
import style0 from "./TwDashBoardNotification.vue?vue&type=style&index=0&id=3479a291&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479a291",
  null
  
)

export default component.exports